import React, { useState, useEffect } from "react" ;
import MessagingAppSidebar from "./Sidebar/MessagingAppSidebar";
import MessagingAppBody from "./Body/MessagingAppBody";

const WieldyApplicationModuleMessaging = (props) =>
{
    const [ height, setHeight ] = useState ( props.height ) ;

    const pageStyle = { height: '' + height + 'px' } ;

    useEffect(() => {
        setHeight(props.height);
    }, [props.height]);

    return (
        <div className="row">
            <div className="col-xl-12">

                { /* Module */}
                <div className="dt-module" style={pageStyle}>

                    <MessagingAppSidebar title={'My Messages'} iconName={'icon-chat'}/>
                    <MessagingAppBody height={props.height} width={props.width} />
                    { /* <MessagingAppDrawer /> */ }

                </div>
            </div>
        </div>
    );
}

export default WieldyApplicationModuleMessaging;